import script from "./BookingQueryFloat.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingQueryFloat.vue?vue&type=script&setup=true&lang=js"

import "./BookingQueryFloat.vue?vue&type=style&index=0&id=201afc72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-201afc72"]])

export default __exports__